import { useMemo } from 'react';
import { years } from '../../../../Common/Filters/Filters';
import { useServicesChartsDataContext } from '../../../../Common/Services/hooks/useServicesChartsDataContext';

const useValuePerYearTotalChart = () => {
    const { chartData, subtitles } = useServicesChartsDataContext();

    const series = useMemo(
        () =>
            subtitles.map((item) => {
                const data = years.map((year) => {
                    const found = chartData.counterYear.find(
                        (counter) =>
                            counter.description === item &&
                            counter.ano_competencia === year
                    );

                    return found ? Number(found.total) : 0;
                });

                return {
                    name: item,
                    data
                };
            }),
        [subtitles, chartData]
    );

    return {
        series,
        subtitles: years
    };
};

export default useValuePerYearTotalChart;
